import {NgModule} from "@angular/core";
import {AboutComponent} from "./about/about.component";
import {HomeComponent} from "./home/home.component";
import {LandingLayoutComponent} from "./layout/landing-layout.component";
import {LandingRoutingModule} from "./landing.routing.module";
import {NgClass, NgForOf, NgIf, SlicePipe} from "@angular/common";
import {FeaturesComponent} from "./features/features.component";
import {PricingComponent} from "./pricing/pricing.component";
import {DiscoverComponent} from "./discover/discover.component";
import {TooltipModule} from "ngx-bootstrap/tooltip";

@NgModule({
  declarations: [
    AboutComponent,
    FeaturesComponent,
    PricingComponent,
    HomeComponent,
    LandingLayoutComponent,
    DiscoverComponent
  ],
    imports: [
        LandingRoutingModule,
        NgClass,
        NgIf,
        NgForOf,
        TooltipModule,
        SlicePipe
    ],
  exports: []
})

export class LandingModule {

}
